import Language, { RTL_LANGUAGES } from '../constants/language';

export const isRTL = (lang: Language | string) => {
    return RTL_LANGUAGES.includes(lang);
};
